'use client';
import progloveLogo from '@/components/proglove/img/proglove-logo-orange.png';
import Box from '@mui/material/Box';
import { type SxProps, type Theme } from '@mui/material/styles';
import Image from 'next/image';
import React from 'react';

interface ProgloveLogoProps {
  height?: number;
  sx?: SxProps<Theme>;
}

/** The official ProGlove wordmark (brand orange on transparent, works on light and dark backgrounds). */
export default function ProgloveLogo({ height = 20, sx }: ProgloveLogoProps): React.JSX.Element {
  return (
    <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', lineHeight: 0, ...sx }}>
      <Image src={progloveLogo} alt="ProGlove" style={{ height, width: 'auto' }} />
    </Box>
  );
}
